<script setup lang="ts">

import {formatting, LegacyOrder, legacyOrderCommands, LegacyRma, LegacyRmaRow} from "@hantera/portal-app";
import useBackend from "@/composition/useBackend";
import {ref} from "vue";
import {useClose} from "@hantera/design-system";

const props = defineProps<{
  rma: LegacyRma
  row: LegacyRmaRow
  order: LegacyOrder
}>();

const backend = useBackend()
const close = useClose()

const response = await backend.fetch('/legacy/graphql', {
  method: 'POST',
  body: JSON.stringify({
    query: `query Inventories(\$articleNumber: String, \$inventoryIds: [Guid]) { hantera {
    inventories {
      inventoryItemsByArticleNumber(
        articleNumber: \$articleNumber,
        inventoryIds: \$inventoryIds
      ) {
        inventoryItems {
          availablePhysicalStock
          inventoryId
          inventoryExternalId
        }
      }
    }
    }}`,
    variables: {
      articleNumber: props.row.exchange!.article.articleNumber,
      inventoryIds: backend.legacyChannels.value[props.order.channelId].inventories.map(i => i.inventoryExternalId)
    }
  })
})

const inventories = (await response.json()).data.hantera.inventories.inventoryItemsByArticleNumber.inventoryItems as any[]

const selected = ref(props.row.exchange?.inventoryExternalId)

function submit() {
  
  if (selected.value == props.row.exchange?.inventoryExternalId || !props.row.exchange) {
    close()
    return
  }
  
  backend.legacyOrders.buildCommandGroup(
    props.order.orderId,
    'Set inventory of exchange to {inventory} on RMA row {rmaNumber}-{rowId}',
    {
      inventory: selected.value,
      rmaNumber: props.rma.rmaNumber,
      rowId: props.row.rmaRowId,
    }
  )
    .command(legacyOrderCommands.upsertRmaRowExchange, {
      rmaId: props.rma.rmaId,
      rmaRowId: props.row.rmaRowId,
      exchangeArticleNumber: props.row.exchange.article.articleNumber,
      inventorySystemId: selected.value
    })
    .command(legacyOrderCommands.addActivityLog, {
      message: 'Inventory of {rmaNumber}-{rowId} exchange set to {inventory}',
      fields: {
        inventory: selected.value,
        rmaNumber: props.rma.rmaNumber,
        rowId: props.row.rmaRowId
      }
    })
    .send();
  
  close()
}

</script>

<template>
  <div v-if="inventories">
    <table class="list">
      <thead>
        <tr>
          <th>&nbsp;</th>
          <th>Inventory</th>
          <th>Available</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="inventory in inventories"
          :key="inventory.inventoryId"
          @click="() => selected = inventory.inventoryId"
          class="option"
        >
          <td>
            <input type="radio" v-model="selected" :value="inventory.inventoryId" />
          </td>
          <td>
            {{inventory.inventoryExternalId}}
          </td>
          <td>
            {{formatting.number(inventory.availablePhysicalStock)}}
          </td>
        </tr>
      </tbody>
    </table>
    
    <div class="actions">
      <button class="btn-primary" @click="submit">Set</button>
    </div>
  </div>
</template>

<style scoped>

.option {
  cursor: pointer;
}

.actions {
  margin-top: 5px;
  text-align: right;
}

</style>